import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import { updateStripeTokenDetails } from "../../../redux/reducers/StripeSlice";


const CARD_OPTIONS = {
	iconStyle: "solid",
	style: {
		base: {
			iconColor: "white",
			color: "#ffffff",
			fontWeight: 500,
			fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
			fontSize: "16px",
			fontSmoothing: "antialiased",
			":-webkit-autofill": { color: "#fce883" },
			"::placeholder": { color: "white" }
		},
		invalid: {
			iconColor: "#ffc7ee",
			color: "#ffc7ee"
		}
	}
}

export default function PaymentForm(prop) {
    const [success, setSuccess ] = useState(false)
    const [errors, setErrors] = useState({});
    const stripe = useStripe();
    const elements = useElements();
    const dispatch = useDispatch();


    const handleSubmit = async (e) => {
        e.preventDefault()
        const {error, token} = await stripe.createToken(elements.getElement(CardElement))
        if(error !== undefined && Object.keys(error).length !== 0) {
            prop.showReviewOrderDetails(false);
            setErrors(error);
        } else {
            setSuccess(true);
            prop.showReviewOrderDetails(true);
            dispatch(updateStripeTokenDetails(token));
            document.body.classList.remove("set-rightBtn");
        }
    }

    const handleCardDetails = (event) => {
        prop.cardType(event.brand)
    }

    return (
        <>
        {!success && 
            <form className="payment-form-popup" onSubmit={handleSubmit}>
              
                <fieldset className="FormGroup">
                    <div className="FormRow">
                        {<CardElement options={CARD_OPTIONS} onChange={(event) => handleCardDetails(event)} /> }
                    </div>
                </fieldset>
                {errors && <p id="creditcardRequired" className="error">{errors.message}</p>}
                <button className="btn btn-bold active" id="nextToPay">Next</button>
            </form> 
        }  
        </>
    )
}